(function() {
    'use strict';

    angular.module('app.filter', []);
})();
